export class CommonState {
  constructor() {
    this.isLoading = false;
    this.data = null;
    this.error = null;
    this.isError = false;
  }
}
